import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { showModal } from 'react-redux-modal-provider';
import { Button } from '@app/components/index';
import FechaFunction from '@app/functions/FechaFunction';
import { Card } from 'react-bootstrap';
import ModalTicketPrioridad from '@app/modals/ticket/ModalTicketPrioridad';
import TextMark from '@app/components/text/TextMark';

const ESTADO_COLOR = {
    ABIERTO:   '#28a745',
    CERRADO:   '#6c757d',
    VENCEHOY:  '#fd7e14',
    PORVENCER: '#ffc107',
    VENCIDO:   '#dc3545',
};

const ACCION_LABEL = {
    ASIGNOG: 'Grupo asignado',
    ASIGNOP: 'Usuario asignado',
};

const getEstadoLabel = (estadoTk, cerradoTk) => {
    if (estadoTk === 'PORVENCER') return 'POR VENCER';
    if (estadoTk === 'VENCIDO' && cerradoTk) return 'CERRADO-VENCIDO';
    return estadoTk;
};

function TicketVistaCard({
    textSearch = '',
    item,
    tratos,
    hideIrTicket,
    onGuardar,
    onCloseModal
}) {
    const navigate = useNavigate();
    const onVerTicket = () => {
        if(onCloseModal){
            onCloseModal()
        }
        navigate(`/tickets/${item?.id_tk}/ver`);
    };
    const onOpenEditar = (ticket, tr) => {
        showModal(ModalTicketPrioridad, {item: ticket, trato: tr, onGuardar});
    };
    const [trato, settrato] = useState();
    useEffect(() => {
        if(tratos && tratos?.length >= 1) settrato(tratos[0]);
    }, []);

    const estadoLabel = getEstadoLabel(item?.estado_tk, item?.cerrado_tk);
    const borderColor = ESTADO_COLOR[item?.estado_tk] || '#ced4da';

    return (
        <Card
            style={{
                backgroundColor: '#F8F8F8',
                borderLeft: `5px solid ${borderColor}`,
                borderRadius: '8px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
            }}
        >
            <Card.Body className="py-2 px-3">
                {/* Fila superior: info + botón */}
                <div className="d-flex justify-content-between align-items-start">
                    <div style={{flex: 1, minWidth: 0}}>
                        {/* Estado + Nro + Incidencia + Fecha */}
                        <div className="d-flex flex-wrap align-items-center mb-1" style={{gap: '6px'}}>
                            <img
                                src="/img/911-logo.png"
                                alt="logo"
                                className="iconoEmpTicketCard"
                                style={{width: '20px', height: '20px', objectFit: 'contain'}}
                            />
                            <span
                                className={`pill pill${item?.estado_tk}`}
                                style={{fontSize: '10px', padding: '2px 8px', borderRadius: '12px', whiteSpace: 'nowrap'}}
                            >
                                {estadoLabel}
                            </span>
                            <span style={{fontSize: '14px', color: '#495057', fontWeight: 600}}>
                                {`#${item?.id_tk}`}
                            </span>
                            {!!item?.idIncidenciaExt_tk && (
                                <span style={{fontSize: '11px', color: '#6c757d'}}>
                                    {`N° Inc: ${item.idIncidenciaExt_tk}`}
                                </span>
                            )}
                            {item?.createdAt && (
                                <span style={{fontSize: '11px', color: '#6c757d'}}>
                                    <i className="far fa-clock mr-1" />
                                    {FechaFunction.format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm')}
                                </span>
                            )}
                        </div>
                        {/* Título */}
                        <h6
                            style={{
                                color: '#345380',
                                fontWeight: item?.visto_tk ? 'normal' : 'bold',
                                marginBottom: '4px',
                                fontSize: '15px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                            title={item?.titulo_tk}
                        >
                            <TextMark texto={item?.titulo_tk} textMark={textSearch} />
                        </h6>
                        {/* Trato / Cámara */}
                        {trato && item?.createdEmp_tk === 'CVV' && (
                            <div style={{fontSize: '12px', marginBottom: '4px'}}>
                                <i className="fas fa-video mr-1" style={{color: '#345380'}} />
                                <Link to={`/tratos/${trato?.id_t}/vercam`}>
                                    {`${trato?.nombre_t}${trato?.direccion_t ? ` — ${trato.direccion_t}` : ''}`}
                                </Link>
                            </div>
                        )}
                    </div>
                    {/* Botón acción */}
                    <div className="ml-3 flex-shrink-0">
                        {hideIrTicket ? (
                            <Button
                                className="btn"
                                style={{fontSize: '0.75em', whiteSpace: 'nowrap'}}
                                onClick={() => onOpenEditar(item, trato)}
                            >
                                Cargar Prioridad
                            </Button>
                        ) : (
                            <Button
                                className="btn"
                                style={{fontSize: '0.75em', whiteSpace: 'nowrap'}}
                                onClick={onVerTicket}
                            >
                                <i className="fas fa-share mr-1" />
                                Ir al Ticket
                            </Button>
                        )}
                    </div>
                </div>

                {/* Sección de última actividad */}
                {(item?.ultimoComentario || item?.ultimoLog) && (
                    <div
                        style={{
                            backgroundColor: '#eef2f7',
                            borderRadius: '6px',
                            padding: '5px 10px',
                            fontSize: '11px',
                            marginTop: '6px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                        }}
                    >
                        {item?.ultimoComentario && (
                            <span>
                                <i className="far fa-comment mr-1" style={{color: '#5a6268'}} />
                                <span style={{color: '#5a6268'}}>Últ. comentario: </span>
                                <strong>{FechaFunction.format(new Date(item.ultimoComentario), 'dd/MM/yyyy HH:mm:ss')}</strong>
                            </span>
                        )}
                        {item?.ultimoLog && (
                            <span>
                                <i className="fas fa-history mr-1" style={{color: '#5a6268'}} />
                                <span style={{color: '#5a6268'}}>Últ. log: </span>
                                <strong>{FechaFunction.format(new Date(item.ultimoLog.createdAt), 'dd/MM/yyyy HH:mm:ss')}</strong>
                                <span
                                    className="badge badge-danger ml-1"
                                    style={{fontSize: '10px', verticalAlign: 'middle'}}
                                >
                                    {ACCION_LABEL[item.ultimoLog.accion] || item.ultimoLog.accion}
                                </span>
                            </span>
                        )}
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}

export default TicketVistaCard;